import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Paperclip, FileText, Image as ImageIcon, Trash2, Loader2, Download } from "lucide-react";

export async function openFile(fileId, filename) {
  const res = await api.get(`/files/${fileId}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export function AttachmentList({ files, isAdmin, onDeleted }) {
  const del = async (f) => {
    try { await api.delete(`/attachments/${f.id}`); toast.success("Adjunto eliminado"); onDeleted(); }
    catch { toast.error("No se pudo eliminar"); }
  };
  if (!files?.length) return null;
  return (
    <ul className="space-y-1" data-testid="attachment-list">
      {files.map((f) => (
        <li key={f.id} className="flex items-center gap-2 text-xs bg-white border rounded px-2 py-1">
          {f.content_type === "application/pdf" ? <FileText className="h-3.5 w-3.5 text-red-500" /> : <ImageIcon className="h-3.5 w-3.5 text-sky-500" />}
          <button className="flex-1 text-left truncate hover:underline" onClick={() => openFile(f.id, f.original_filename)}
            data-testid={`attachment-${f.id}`}>{f.original_filename}</button>
          <span className="text-muted-foreground">{(f.size / 1024).toFixed(0)} KB</span>
          <Download className="h-3.5 w-3.5 text-muted-foreground cursor-pointer" onClick={() => openFile(f.id, f.original_filename)} />
          {isAdmin && f.kind !== "recibo_epi" && (
            <Trash2 className="h-3.5 w-3.5 text-red-500 cursor-pointer" onClick={() => del(f)} data-testid={`delete-attachment-${f.id}`} />
          )}
        </li>
      ))}
    </ul>
  );
}

export function UploadButton({ employeeId, section, itemId, onUploaded }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!itemId) return toast.error("Guarda la ficha antes de adjuntar");
    setBusy(true);
    const fd = new FormData();
    fd.append("section", section); fd.append("item_id", itemId); fd.append("file", file);
    try {
      await api.post(`/employees/${employeeId}/attachments`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Certificado adjuntado");
      onUploaded();
    } catch (err) { toast.error(err.response?.data?.detail || "No se pudo subir el archivo"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <input ref={ref} type="file" accept="application/pdf,image/*" className="hidden" onChange={upload}
        data-testid={`upload-input-${itemId}`} />
      <Button type="button" size="sm" variant="ghost" className="h-7 text-xs" disabled={busy} onClick={() => ref.current?.click()}
        data-testid={`upload-button-${itemId}`}>
        {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Paperclip className="h-3.5 w-3.5 mr-1" />} Adjuntar certificado
      </Button>
    </>
  );
}
